export const ADD_CUSTOMER_SUCCESS = "Le client a été ajouté.";
export const DELETE_CUSTOMER_SUCCESS = "Le client a été supprimé.";
export const BULK_DELETE_CUSTOMER_SUCCESS = "Les clients sélectionnés ont été supprimés.";
export const UPDATE_CUSTOMER_SUCCESS = "Le client a été modifié.";
export const FUSE_CUSTOMERS_SUCCESS = "Les clients ont été fusionnés.";



// WEBPACK FOOTER //
// ./src/successes/customers.js